import { CLARITY_GENERATED_FILE } from './constants/clarity-generated-file.constant';

const MANAGED_CHROME_LINES: ReadonlySet<string> = new Set([
	CLARITY_GENERATED_FILE.BEGIN_MARKER,
	CLARITY_GENERATED_FILE.END_MARKER,
	CLARITY_GENERATED_FILE.BANNER,
]);

/** Ported from Clarity `apps/web/src/features/domains/utils/frontmatter.ts` (commit `6750a5f43`). */
/**
 * Remove a Generated file's managed chrome — every line whose trimmed text is the opening marker, the closing marker
 * or the AUTO-GENERATED banner — and the blank lines left at either end, keeping the listing or table between them
 * (`frontmatter.ts:42–58`). An empty body is returned as it is.
 *
 * Only lines that are nothing but the chrome go; a line that quotes a marker beside other text stays.
 *
 * @param body The file's body, frontmatter already stripped.
 * @returns The body without its managed chrome.
 */
export function stripManagedChrome(body: string): string {
	if (!body) {
		return body;
	}

	const kept = body.split('\n').filter(line => !MANAGED_CHROME_LINES.has(line.trim()));

	while (kept.length > 0 && kept[0].trim() === '') {
		kept.shift();
	}

	while (kept.length > 0 && kept.at(-1)?.trim() === '') {
		kept.pop();
	}

	return kept.join('\n');
}
